// extracted by mini-css-extract-plugin
export default {"Header":"PortalHeader_Header__6li6U","Title":"PortalHeader_Title__vkfgz"};